import { render, staticRenderFns } from "./KSindex.vue?vue&type=template&id=0927f546&scoped=true"
import script from "./KSindex.vue?vue&type=script&lang=js"
export * from "./KSindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0927f546",
  null
  
)

export default component.exports